__turbopack_context__.v({
  "className": "Mla6za_className",
  "variable": "Mla6za_variable",
});
